export default {
  mounted() {
    // 检查是否已经加载gtag
    if (!window.gtag) {
      // 加载gtag脚本
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtag/js?id=' + i + dl;
        j.setAttribute('data-cookieless', '1'); // 设置为cookieless跟踪
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'G-W9CLSDHVX3');
 
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-W9CLSDHVX3');
    }
  }
};